import { useEffect, useState, useRef } from "react";

const AnimatedNumber = ({ value, duration = 2000 }) => {
  const [currentValue, setCurrentValue] = useState(0);
  const ref = useRef(null);
  const observer = useRef(null);

  useEffect(() => {
    observer.current = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          animateValue(0, value, duration);
        }
      },
      { threshold: 0.5 }
    );

    if (ref.current) {
      observer.current.observe(ref.current);
    }

    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, [value, duration]);

  const animateValue = (start, end, duration) => {
    let startTime;
    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      setCurrentValue(Math.floor(progress * (end - start) + start));
      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };
    requestAnimationFrame(step);
  };

  const formatNumber = (num) => {
    return num.toLocaleString();
  };

  return (
    <span
      ref={ref}
      className={
        "bg-[linear-gradient(90deg,_#00FF8F_0%,_#33B4FF_100%)] inline-block text-transparent bg-clip-text transition-opacity opacity-0 animate-fadeIn"
      }
    >
      ${formatNumber(currentValue)}+
    </span>
  );
};

export default AnimatedNumber;
